/**
 * Texts for Factsheets page
 *
 * PDF DOWNLOAD INSTRUCTIONS:
 * Each factsheet has an image and a PDF download URL.
 * On image click, the PDF will be downloaded.
 *
 * Single category: Use 'category' and 'pdfUrl'.
 * Both categories (Dana + YpsoPump) with different PDFs: Use 'categories' array and 'pdfUrls' object.
 *   - categories: ['dana', 'ypso']
 *   - pdfUrls: { dana: '/path/to/dana.pdf', ypso: '/path/to/ypso.pdf' }
 */
export const factsheetsPageText = {
  title: "Factsheets - CamAPS FX",
  titleMeta: "CamAPS FX Factsheets - Quick reference guides",
  descriptionMeta:
    "Download helpful factsheets and guides for quick reference about CamAPS FX.",
  keywords:
    "camaps fx factsheets, camaps guides, diabetes app guides, insulin pump factsheets, cgm guides, pdf downloads",
  localeMeta: "en_gb",

  mainHeader: "Factsheets",
  mainSubHeader:
    "Downloadable starting guides to provide you with further information.",

  filterAll: "All",
  filterYpsoPump: "YpsoPump",
  filterDana: "Dana",
  sortNewest: "Newest",
  sortOldest: "Oldest",
  sortAZ: "A-Z",
  sortPopular: "Most popular",

  // Getting Started Section
  virtualModeTooltipText: "Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.",
  gettingStartedHeader: "Ready to get started?",
  step1Title: "<strong>Step 1:</strong> Download the app",
  step2Title: "<strong>Step 2:</strong> Create an account",
  step3Title: "<strong>Step 3:</strong> Begin the in-app essential training",
  step4Title: "<strong>Step 4:</strong> Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>",

  // Support Section
  supportSectionTitle: "Need help installing the app?",
  supportSectionText: "Visit our support section for guidance",
  supportButtonText: "SUPPORT",

  factsheets: [
    // {
    //     id: 1,
    //     title: 'Linking CamAPS FX to Glooko',
    //     description: 'Linking CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-001.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-001-linking-glooko.pdf'
    // },
    // {
    //     id: 2,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-002.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-002-pdf-report.pdf'
    // },
    // {
    //     id: 3,
    //     title: 'Managing Hypos on CamAPS FX',
    //     description: 'Managing Hypos on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-003.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-003-managing-hypos.pdf'
    // },
    // {
    //     id: 4,
    //     title: 'Managing Illness on CamAPS FX',
    //     description: 'Managing Illness on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-004.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-004-managing-illness.pdf'
    // },
    // {
    //     id: 5,
    //     title: 'Managing Meals on CamAPS FX',
    //     description: 'Managing Meals on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-005.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-005-managing-meals.pdf'
    // },
    // {
    //     id: 6,
    //     title: 'Travelling with CamAPS FX',
    //     description: 'Travelling with CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-006.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-006-travelling.pdf'
    // },
    // {
    //     id: 7,
    //     title: 'Getting support on CamAPS FX',
    //     description: 'Getting support on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-007.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-007-getting-support.pdf'
    // },
    // {
    //     id: 8,
    //     title: 'Using CamAPS FX at school, nursery or in childcare',
    //     description: 'Using CamAPS FX at school, nursery or in childcare',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-008.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-008-at-school.pdf'
    // },
    // {
    //     id: 9,
    //     title: 'CamAPS FX School\'s Care Plan Template',
    //     description: 'CamAPS FX School\'s Care Plan Template',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-009.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-009-care-plan-template.docx'
    // },
    // {
    //     id: 10,
    //     title: 'Using CamAPS FX in virtual (demo) mode',
    //     description: 'Using CamAPS FX in virtual (demo) mode',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-010.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-010-demo-mode.pdf'
    // },
    // {
    //     id: 11,
    //     title: 'CamAPS FX and its Patency Pulse',
    //     description: 'CamAPS FX and its Patency Pulse',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-011.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-011-patency-pulse.pdf'
    // },
    // {
    //     id: 12,
    //     title: 'Having Surgery or a Procedure when using CamAPS FX',
    //     description: 'Having Surgery or a Procedure when using CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-012.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-012-surgery-procedure.pdf'
    // },
    // {
    //     id: 13,
    //     title: 'Managing Pregnancy on CamAPS FX',
    //     description: 'Managing Pregnancy on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-013.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-013-managing-pregnancy.pdf'
    // },
    // {
    //     id: 14,
    //     title: 'Optimising CamAPS FX',
    //     description: 'Optimising CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-014.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-014-optimising.pdf'
    // },
    // {
    //     id: 15,
    //     title: 'Starting CamAPS FX - training slide deck',
    //     description: 'Starting CamAPS FX - training slide deck',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-015.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-015-training-slides.pdf'
    // },
    // {
    //     id: 16,
    //     title: 'Preparing to start CamAPS FX',
    //     description: 'Preparing to start CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-016.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-016-preparing-to-start.pdf'
    // },
    // {
    //     id: 17,
    //     title: 'Introduction to mylife CamAPS FX',
    //     description: 'Introduction to mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-017.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-017-introduction-uk-en.pdf'
    // },
    // {
    //     id: 18,
    //     title: 'mylife CamAPS FX Specifications',
    //     description: 'mylife CamAPS FX Specifications',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-018.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-018-specifications-uk-en.pdf'
    // },
    // {
    //     id: 19,
    //     title: 'mylife CamAPS FX Infographic',
    //     description: 'mylife CamAPS FX Infographic',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-019.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-019-infographic-uk-en.pdf'
    // },
    // {
    //     id: 20,
    //     title: 'Choice of Sensors',
    //     description: 'Choice of Sensors',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-020.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-020-sensors-uk-en.pdf'
    // },
    // {
    //     id: 21,
    //     title: 'Starting mylife CamAPS FX',
    //     description: 'Starting mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-021.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-021-starting-uk-en.pdf'
    // },
    // {
    //     id: 22,
    //     title: 'Patency pulse on mylife CamAPS FX',
    //     description: 'Patency pulse on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-022.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-022-patency-pulse-uk-en.pdf'
    // },
    // {
    //     id: 23,
    //     title: 'Travelling with mylife CamAPS FX',
    //     description: 'Travelling with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-023.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-023-travelling-uk-en.pdf'
    // },
    // {
    //     id: 24,
    //     title: 'Managing illness on mylife CamAPS FX',
    //     description: 'Managing illness on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-024.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-024-illness-uk-en.pdf'
    // },
    // {
    //     id: 25,
    //     title: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     description: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-025.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-025-surgery-uk-en.pdf'
    // },
    // {
    //     id: 26,
    //     title: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     description: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-026.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-026-hypos-uk-en.pdf'
    // },
    // {
    //     id: 27,
    //     title: 'Optimising mylife CamAPS FX',
    //     description: 'Optimising mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-027.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-027-optimising-uk-en.pdf'
    // },
    // {
    //     id: 28,
    //     title: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     description: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-028.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-028-school-uk-en.pdf'
    // },
    // {
    //     id: 29,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-029.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-029-pdf-report.pdf'
    // },
    // {
    //     id: 30,
    //     title: 'Linking mylife CamAPS FX to Glooko',
    //     description: 'Linking mylife CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-030.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-030-linking-glooko.pdf'
    // },
    // {
    //     id: 31,
    //     title: 'Ajuste del tamaño de las comidas preajustado',
    //     description: 'Adjusting preset meal sizes',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-031.jpg',
    //     pdfUrl: '/pdfs/factsheets/adjusting_meal_sizes_camdiab_EN.pdf'
    // }

    // {
    //     id: 1,
    //     title: 'Adjusting preset meal sizes',
    //     description: 'Adjusting preset meal sizes',
    //     date: '20 Jun 2024',
    //     category: 'all',
    //     image: '/images/factsheets/thumbnail/adjusting_meal_sizes.webp',
    //     pdfUrl: '/pdfs/factsheets/en_GB/adjusting_meal_sizes_camdiab_EN.pdf'
    // }

    {
      id: 1,
      title: "Adjusting preset meal sizes",
      description: "Adjusting preset meal sizes",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/adjusting_meal_sizes.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/adjusting_meal_sizes_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/adjusting_meal_sizes_camdiab_EN.pdf",
      },
      views: 4000,
    },
    {
      id: 2,
      title: "Calibrating a sensor",
      description: "Calibrating a sensor",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/calibrating_a_sensor.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/calibrating_a_sensor_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/calibrating_a_sensor_camdiab_EN.pdf",
      },
      views: 3000,
    },
    {
      id: 3,
      title: "Changing carbohydrate units",
      description: "Changing carbohydrate units",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/changing_carbohydrate_units.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/changing_carbohydrate_units_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/changing_carbohydrate_units_camdiab_EN.pdf",
      },
      views: 2000,
    },
    {
      id: 4,
      title: "Entering body weight",
      description: "Entering body weight",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/entering_body_weight.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/entering_body_weight_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/entering_body_weight_camdiab_EN.pdf",
      },
      views: 31000,
    },
    {
      id: 5,
      title: "Entering Total Daily Dose (TDD)",
      description: "Entering Total Daily Dose (TDD)",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/entering_total_daily_dose.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/entering_total_daily_dose_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/entering_total_daily_dose_camdiab_EN.pdf",
      },
      views: 30000,
    },
    {
      id: 6,
      title: "Giving a manual correction",
      description: "Giving a manual correction",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/giving_a_correction.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/giving_a_correction_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/giving_a_correction_camdiab_EN.pdf",
      },
      views: 22000,
    },
    {
      id: 7,
      title: "Giving a meal bolus",
      description: "Giving a meal bolus",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/giving_a_meal_bolus.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/giving_a_meal_bolus_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/giving_a_meal_bolus_camdiab_EN.pdf",
      },
      views: 26000,
    },
    {
      id: 8,
      title: "How does CamAPS FX deliver insulin?",
      description: "How does CamAPS FX deliver insulin?",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_deliver_insulin.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/how_does_camaps_fx_deliver_insulin_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/how_does_camaps_fx_deliver_insulin_camdiab_EN.pdf",
      },
      views: 35000,
    },
    {
      id: 9,
      title: "How does CamAPS FX learn?",
      description: "How does CamAPS FX learn?",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_learn.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/how_does_camaps_fx_learn_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/how_does_camaps_fx_learn_camdiab_EN.pdf",
      },
      views: 36000,
    },
    {
      id: 10,
      title: "Managing Pregnancy",
      description: "Managing Pregnancy",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/managing_pregnancy.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/managing_pregnancy_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/managing_pregnancy_camdiab_EN.pdf",
      },
      views: 34000,
    },
    {
      id: 11,
      title: "Pairing the pump and sensor",
      description: "Pairing the pump and sensor",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/pairing_pump_and_sensor.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/pairing_pump_and_sensor_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/pairing_pump_and_sensor_camdiab_EN.pdf",
      },
      views: 32000,
    },
    {
      id: 12,
      title: "Patency pulse",
      description: "Patency pulse",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/patency_pulse.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/patency_pulse_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/patency_pulse_camdiab_EN.pdf",
      },
      views: 1000,
    },
    {
      id: 13,
      title: "Programming the Bolus Calculator",
      description: "Programming the Bolus Calculator",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/programming_bolus_calculator.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/programming_bolus_calculator_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/programming_bolus_calculator_camdiab_EN.pdf",
      },
      views: 29000,
    },
    {
      id: 14,
      title: "Alerts",
      description: "Alerts",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/setting_alerts.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/setting_alerts_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/setting_alerts_camdiab_EN.pdf",
      },
      views: 21000,
    },
    {
      id: 15,
      title: "Personal Glucose Target (PGT)",
      description: "Personal Glucose Target (PGT)",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/setting_personal_glucose_target.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/setting_personal_glucose_target_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/setting_personal_glucose_target_camdiab_EN.pdf",
      },
      views: 28000,
    },
    {
      id: 16,
      title: "Sharing Diabetes Data",
      description: "Sharing Diabetes Data",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/sharing_diabetes_data.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/sharing_diabetes_data_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/sharing_diabetes_data_camdiab_EN.pdf",
      },
      views: 20000,
    },
    {
      id: 17,
      title: "Top Technical Tips",
      description: "Top Technical Tips",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/top_technical_tips.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/top_technical_tips_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/top_technical_tips_camdiab_EN.pdf",
      },
      views: 33000,
    },
    {
      id: 18,
      title: "Using \u201cAdd meal\u201d",
      description: "Using \u201cAdd meal\u201d",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/using_add_meal.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/using_add_meal_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/using_add_meal_camdiab_EN.pdf",
      },
      views: 25000,
    },
    {
      id: 19,
      title: "Using \u201cAuto mode\u201d",
      description: "Using \u201cAuto mode\u201d",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/using_auto_mode.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/using_auto_mode_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/using_auto_mode_camdiab_EN.pdf",
      },
      views: 27000,
    },
    {
      id: 20,
      title: "Using \u201cBlock\u201d",
      description: "Using \u201cBlock\u201d",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/using_block.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/using_block_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/using_block_camdiab_EN.pdf",
      },
      views: 19000,
    },
    {
      id: 21,
      title: "Using \u201cBoost\u201d",
      description: "Using \u201cBoost\u201d",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/using_boost.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/using_boost_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/using_boost_camdiab_EN.pdf",
      },
      views: 23000,
    },
    {
      id: 22,
      title: "Using \u201cEase-off\u201d",
      description: "Using \u201cEase-off\u201d",
      date: "20 Jun 2024",
      categories: ["dana", "ypso"],
      image: "/images/factsheets/thumbnail/using_ease_off.webp",
      pdfUrls: {
        dana: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB_dana/using_ease_off_camdiab_EN.pdf",
        ypso: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/en_GB/using_ease_off_camdiab_EN.pdf",
      },
      views: 24000,
    },
  ],
};
